import {
    defaultTypeTipPrudence,
    defaultFilterTypesTipPrudenceSga,
} from "./state";

/**
 * Mutación que lista los tipos de consejo de prudencia de SGA.
 *
 * @param {*} state.typesTipPrudenceSga - Estado de los tipos de consejo de prudencia de SGA.
 * @param typesTipPrudenceSga - Tipos de consejo de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setTypesTipPrudenceSga(state, typesTipPrudenceSga) {
    state.typesTipPrudenceSga = typesTipPrudenceSga;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionTypeTipPrudenceSga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece el tipo de consejo de prudencia por defecto.
 *
 * @param {*} state.typeTipPrudence - Estado del tipo de consejo de prudencia.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultTypeTipPrudenceSga(state) {
    state.typeTipPrudence = defaultTypeTipPrudence();
}

/**
 * Mutación que establece el filtro de los tipos de consejo de prudencia de SGA por defecto.
 *
 * @param {*} state.filterTypesTipPrudenceSga - Estado del filtro de los tipos de consejo de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterTypesTipPrudence(state) {
    state.filterTypesTipPrudenceSga = defaultFilterTypesTipPrudenceSga();
}

/**
 * Mutación que establece la cantidad de tipos de consejo de prudencia por página.
 *
 * @param {*} state.filterTypesTipPrudenceSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterTypesTipPrudenceSga.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterTypesTipPrudenceSga = {
        ...state.filterTypesTipPrudenceSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterTypesTipPrudenceSga.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterTypesTipPrudenceSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de tipos de consejo de prudencia.
 *
 * @param {*} state.filterTypesTipPrudenceSga.page - Página actual.
 * @param {*} state.filterTypesTipPrudenceSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterTypesTipPrudenceSga.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateTypesTipPrudenceSga(state, paginate) {
    state.filterTypesTipPrudenceSga = {
        ...state.filterTypesTipPrudenceSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece el tipo de consejo de prudencia de SGA.
 *
 * @param {*} state.typeTipPrudence - Estado del tipo de consejo de prudencia.
 * @param typeTipPrudence - Tipo de consejo de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setTypeTipPrudenceSga(state, typeTipPrudence) {
    state.typeTipPrudence = {
        id: typeTipPrudence.id,
        name: typeTipPrudence.name,
        sga_prudence_tip_type_languages:
            typeTipPrudence.sga_prudence_tip_type_languages,
    };
}

/**
 * Mutación que establece los tipos de consejo de prudencia activos de SGA.
 *
 * @param {*} state.activeTypesTipPrudenceSga - Estado de los tipos de consejo de prudencia activos de SGA.
 * @param activeTypesTipPrudenceSga - Tipos de consejo de prudencia activos de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveTypesTipPrudenceSga(state, activeTypesTipPrudenceSga) {
    state.activeTypesTipPrudenceSga = activeTypesTipPrudenceSga;
}
